import { useEffect, useRef } from "react"

type Props = {
  pair: string // ex: BTC_USDT
}

const ChartSection = ({ pair }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const symbol = `BINANCE:${pair.replace("_", "")}`

  useEffect(() => {
    // Remove old widget if exists
    containerRef.current!.innerHTML = ""

    const script = document.createElement("script")
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js"
    script.type = "text/javascript"
    script.async = true
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol: symbol,
      interval: "15",
      timezone: "Etc/UTC",
      theme: "dark",
      style: "1",
      locale: "en",
      enable_publishing: false,
      withdateranges: true,
      hide_side_toolbar: false,
      allow_symbol_change: false,
      details: false,
      studies: ["MACD@tv-basicstudies"],
      container_id: "tv_chart_container"
    })

    containerRef.current?.appendChild(script)
  }, [symbol])

  return (
    <div
      ref={containerRef}
      id="tv_chart_container"
      style={{ height: "100%", width: "100%" }}
    />
  )
}

export default ChartSection
